import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { CustomerLoyaltyInfo } from '../../../../../models/customer.model';
import { Card } from '../../../../../models/loyalty-card.model';
import { KontableComponent } from '../../../../../modules/UIKit/components/kontable/kontable.component';
import { LoyaltyMovementService } from '../../../../../services/loyalty/loyalty-movement.service';

@Component({
  selector: 'kv-point-transfer',
  template: `
    <div class="ui-g customer-list">

<!--      <div class="ui-g-12 text-right">-->

<!--        <button pButton type="button" class="k-generic-btn" icon="fa fa-chevron-left"-->
<!--                iconPos="left" label="{{ 'common.back' | translate }}"-->
<!--                (click)="_onBack()"-->
<!--        ></button>-->


<!--      </div>-->
      <div class="ui-g-12 ui-lg-6">
        <h2>{{'loyalty.point_transfer' | translate}}</h2>
      </div>

      <kv-customer-card-search
        (onCardSelect)="onTransferConfirm($event)"
        (onBack)="_onBack()"
      ></kv-customer-card-search>
    </div>
    <p-dialog *ngIf="showTransferDialog && maxPoint != -1"
              header="{{ 'loyalty.transfer_dialog' | translate }}"
              (onHide)="showTransferDialog = false"
              [(visible)]="showTransferDialog"
              [modal]="true"
              [draggable]="false"
              [resizable]="false">
      <kv-point-transfer-dialog
        *ngIf="showTransferDialog && maxPoint != -1"
        [maxPoint]="maxPoint"
        (onConfirm)="onTransferConfirmProceed($event)"
      >

      </kv-point-transfer-dialog>

    </p-dialog>
  `
})
export class PointTransferComponent {

  @Input() transferSource: any;
  @Input() customerSource: CustomerLoyaltyInfo;
  @Output() onBack: EventEmitter<any> = new EventEmitter<any>();

  searchForm: FormGroup;
  paginationType = KontableComponent.ClientPagination;
  showTransferDialog = false;
  maxPoint = -1;

  transferDestination: Card;

  constructor(
    private fb: FormBuilder,
    private svcMovement: LoyaltyMovementService,
    private translate: TranslateService,
    private svcNotify: MessageService

  ) {

    this.searchForm = this.fb.group({
      surname: new FormControl(null),
      name: new FormControl(null),
      card_no: new FormControl(null)
    })

  }



  _onBack() {
    this.onBack.emit();

  }

  onTransferConfirm(data: Card) {
    console.log(this.transferSource)
    this.maxPoint = this.transferSource['balance'];
    this.transferDestination = data;
    this.showTransferDialog = true;
  }

  onTransferConfirmProceed(transferBalance) {
    console.log('transfer from ' + this.transferSource)
    console.log(' to ', this.transferDestination, ' amount ' + transferBalance)

    this.translate.get(['loyalty.transfer_point_message_ok_header', 'loyalty.transfer_point_message_ok_body']).subscribe(t => {
      this.svcMovement.transferPoints({
        accumulatorId: this.transferSource['id'],
        value: transferBalance,
        customerFrom: this.customerSource.id,
        customerTo:this.transferDestination.vCustomerId
      }).subscribe(res => {
        this.svcNotify.add({severity: 'success', summary: t['loyalty.transfer_point_message_ok_header'], detail: t['transfer_point_message_ok_body']})
        this.showTransferDialog = false;
      })
    })


  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/components/point-transfer.component.ts